module.exports = __webpack_public_path__ + "img/green-1-mb.bbd921c1.png";